import { LangType, validateLang } from '../../../../../../../../helpers/lang';
import { validate } from '../../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../../../hooks/use-query-params';
import { DishSectionType } from '../../../../../../../../store/api/dish-section-api';
import { useDishSectionStore } from '../../../../../../../../store/use-dish-section-store';
import { useInputLangStore } from '../../../../../../../../store/use-input-lang-store';
import { getCurrentMenu } from '../../../menu-informer-helpers';

export const useMenuInformerCreateSectionsModal = () => {
  const { isLoading, deleteSection, putSection, postSection, setSectionListOrder } =
    useDishSectionStore();

  const menu = getCurrentMenu();
  const { language } = useInputLangStore();
  const { t, getLocale } = useLang();

  const { addQueryParams } = useQueryParams();

  const sections = menu?.sections || [];

  const handleDelete = (e: React.MouseEvent, item: DishSectionType) => {
    e.stopPropagation();
    addQueryParams({ sectionId: String(item?.id), name: getLocale(item?.name) });
  };

  const handleCloseDelete = () => {
    addQueryParams({ sectionId: undefined, name: undefined });
  };

  const handleUpdate = async (item: DishSectionType) => {
    const isValid = validate({ editSectionName: { rule: () => validateLang(item.name) } });
    if (!isValid) return;
    await putSection(item);
  };

  const handleCreate = async (data: LangType = {}) => {
    const isValid = validate({ createSectionName: { rule: () => validateLang(data) } });
    if (!isValid) return;
    await postSection({ name: data });
  };

  return {
    t,
    sections,
    isLoading,
    handleDelete,
    handleCloseDelete,
    handleUpdate,
    handleCreate,
    getLocale,
    setSectionListOrder,
    deleteSection,
    addQueryParams,

    language,
  };
};
